<template>
  <div class="courseware-error-page">
    <section class="info-box">
      <img class="info-logo" src="@assets/images/reject-logo.png">
      <div class="text-box">
        <div class="text">各位老师，本系统只能在工作日上午09:00—下午17:00使用 请知悉！</div>
      </div>
      <div class="btn-box">
        <el-button type="primary" size="small" @click="enter">确 定</el-button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'RejectLogin',
  data() {
    return {

    }
  },
  created() {},
  methods: {
    enter () {
      this.$router.push('login')
    }
  }
}
</script>

<style lang='scss'>
 .courseware-error-page{
   position: absolute;
   left: 0;
   right: 0;
   top: 0;
   bottom: 0;
   background-color: #B0E098;
   display: flex;
   justify-content: center;
   align-items: center;
   .info-box{
     width: 410px;
     margin-bottom: 100px;
   }
   .text-box{
    padding: 50px 20px 30px 20px;
    background: #fff;
    border-radius: 12px 12px 0 0;
    text-align: center;
   }
   .btn-box{
    height: 72px;
    line-height: 72px;
    background: #fafafa;
    border-radius: 0 0 12px 12px;
    text-align: center;
   }
   .info-logo{
    width: 100%;
   }
   .text{
     color: #898884;
     font-size:  14px ;
     line-height: 1.5;
   }
 }

</style>
